import { graphql } from '@gql';

export const GET_COMPONENTS_PAGED = graphql(`
    query GetComponentsPaged(
        $first: Int
        $last: Int
        $after: Cursor
        $before: Cursor
        $where: ComponentWhereInput
        $orderBy: ComponentOrder
    ) {
        components(
            first: $first
            last: $last
            after: $after
            before: $before
            where: $where
            orderBy: $orderBy
        ) {
            totalCount
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                cursor
                node {
                    ...ComponentFragment
                }
            }
        }
    }
`);

export const GET_COMPONENTS_SEARCH_PAGED = graphql(`
    query GetComponentsSearchPaged(
        $first: Int
        $last: Int
        $after: Cursor
        $before: Cursor
        $where: ComponentWhereInput
        $orderBy: ComponentOrder
    ) {
        components(
            first: $first
            last: $last
            after: $after
            before: $before
            where: $where
            orderBy: $orderBy
        ) {
            totalCount
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                cursor
                node {
                    ...ComponentPartialFragment
                    updateTime
                }
            }
        }
    }
`);
